"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfMeasurementsClient = void 0;
/** /measurements docs: https://cardata.apps.emea.vwapps.io/documentation#tag/Measurements/operation/getMeasurements */
class VcfMeasurementsClient {
    constructor(authService, stage, gdcType) {
        this.authService = authService;
        this.stage = stage;
        this.gdcType = gdcType;
        this.headers = {
            'User-Id': '__userId__',
            'Content-Type': 'application/json;version=1',
        };
        this.resourceHostId = `myvw-vcf-${this.stage}`;
    }
    async getMeasurementsStatus(vin, id = 'range') {
        const url = `vehicles/${vin}/measurements?gdc=${this.gdcType}&id=${id}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (!response.ok) {
            throw new Error(`Request to /measurements failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.VcfMeasurementsClient = VcfMeasurementsClient;
//# sourceMappingURL=VcfMeasurementsClient.js.map